'use strict';

export default [
  {
    'code': 'AED',
    'symbol': 'د.إ',
    'maxValue': 300,
    'maxSearchValue': 360,
    'maxLength': 3
  },
  {
    'code': 'AUD',
    'symbol': '$',
    'maxValue': 100,
    'maxSearchValue': 120,
    'maxLength': 3
  },
  {
    'code': 'CAD',
    'symbol': '$',
    'maxValue': 100,
    'maxSearchValue': 120,
    'maxLength': 3
  },
  {
    'code': 'CHF',
    'symbol': 'CHF',
    'maxValue': 80,
    'maxSearchValue': 100,
    'maxLength': 2
  },
  {
    'code': 'CNY',
    'symbol': '¥',
    'maxValue': 500,
    'maxSearchValue': 600,
    'maxLength': 3
  },
  {
    'code': 'DKK',
    'symbol': 'kr',
    'maxValue': 500,
    'maxSearchValue': 600,
    'maxLength': 3
  },
  {
    'code': 'EUR',
    'symbol': '€',
    'maxValue': 90,
    'maxSearchValue': 110,
    'maxLength': 2
  },
  {
    'code': 'GBP',
    'symbol': '£',
    'maxValue': 60,
    'maxSearchValue': 80,
    'maxLength': 2
  },
  {
    'code': 'HKD',
    'symbol': '$',
    'maxValue': 600,
    'maxSearchValue': 750,
    'maxLength': 3
  },
  {
    'code': 'IDR',
    'symbol': 'Rp',
    'maxValue': 1000000,
    'maxSearchValue': 1200000,
    'maxLength': 7
  },
  {
    'code': 'ILS',
    'symbol': '₪',
    'maxValue': 300,
    'maxSearchValue': 360,
    'maxLength': 3
  },
  {
    'code': 'INR',
    'symbol': '₹',
    'maxValue': 5000,
    'maxSearchValue': 6000,
    'maxLength': 4
  },
  {
    'code': 'JPY',
    'symbol': '¥',
    'maxValue': 9000,
    'maxSearchValue': 11000,
    'maxLength': 4
  },
  {
    'code': 'MXN',
    'symbol': '$',
    'maxValue': 1400,
    'maxSearchValue': 1700,
    'maxLength': 4
  },
  {
    'code': 'NOK',
    'symbol': 'kr',
    'maxValue': 700,
    'maxSearchValue': 850,
    'maxLength': 3
  },
  {
    'code': 'NZD',
    'symbol': '$',
    'maxValue': 120,
    'maxSearchValue': 150,
    'maxLength': 3
  },
  {
    'code': 'RUB',
    'symbol': '₽',
    'maxValue': 5300,
    'maxSearchValue': 6500,
    'maxLength': 4
  },
  {
    'code': 'SAR',
    'symbol': '﷼',
    'maxValue': 300,
    'maxSearchValue': 360,
    'maxLength': 3
  },
  {
    'code': 'SEK',
    'symbol': 'kr',
    'maxValue': 650,
    'maxSearchValue': 800,
    'maxLength': 3
  },
  {
    'code': 'SGD',
    'symbol': '$',
    'maxValue': 100,
    'maxSearchValue': 120,
    'maxLength': 3
  },
  {
    'code': 'TRY',
    'symbol': '₺',
    'maxValue': 200,
    'maxSearchValue': 250,
    'maxLength': 3
  },
  {
    'code': 'TWD',
    'symbol': 'NT$',
    'maxValue': 2500,
    'maxSearchValue': 3000,
    'maxLength': 4
  },
  {
    'code': 'USD',
    'symbol': '$',
    'maxValue': 80,
    'maxSearchValue': 100,
    'maxLength': 2
  },
  {
    'code': 'THB',
    'symbol': '฿',
    'maxValue': 3400,
    'maxSearchValue': 4150,
    'maxLength': 3
  },
  {
    'code': 'ZAR',
    'symbol': 'R',
    'maxValue': 1200,
    'maxSearchValue': 1500,
    'maxLength': 3
  }
];



// WEBPACK FOOTER //
// ./app/src/constants/currencies.js